import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <CircularProgress color='info' />
    </div>
  );
}

export default Loader;